(function () {
  'use strict';
  if (window.SoulyshineDrawer) return;
  var VERSION = '20260910-1';
  var drawer, originalRender, originalOpen, originalClose, model;
  var running = Promise.resolve(), busy = false, currentCart = null;
  var queuedRefresh = false, refreshTimer, nativeRendering = false;
  var pendingTasks = 0, pendingAddRenders = 0, externalRevision = 0;
  var closeRevision = 0;
  var interactionRevision = 0, taskFocus = null, pendingFocusRestore = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
  // Shopify removes the preview query after loading a draft. Keep section
  // requests on that draft even when preview cookies are unavailable to Ajax.
  if (!previewId && window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'unpublished') previewId = String(window.Shopify.theme.id);
  function route(value) { return root.replace(/\/?$/, '/') + value; }
  function contextUrl() {
    var url = new URL(route('cart'), window.location.origin);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return url;
  }
  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return ids;
  }
  async function request(url, options) {
    var response = await fetch(url, Object.assign({credentials:'same-origin', headers:{Accept:'application/json'}}, options));
    var body = await response.json().catch(function () { return {}; });
    if (!response.ok || body.errors) throw new Error(body.description || body.message || (typeof body.errors === 'string' ? body.errors : 'Your cart could not be updated. Please try again.'));
    return body;
  }
  function readCart() { return request(route('cart.js')); }
  function signature(cart) {
    return JSON.stringify((cart.items || []).map(function (i) {return [i.key, i.quantity, i.final_line_price, (i.properties || {})['_customily-preview']];}));
  }
  async function settledCart() {
    var previous = await readCart(), stable = 0;
    for (var i=0; i<8; i++) {
      await new Promise(function (resolve) {setTimeout(resolve, 250);});
      var next = await readCart();
      stable = signature(previous) === signature(next) ? stable + 1 : 0;
      previous = next;
      if (stable >= 2) return next;
    }
    return previous;
  }
  async function sections() {
    var url = contextUrl(); url.searchParams.set('sections', sectionIds().join(','));
    // /cart negotiates Accept: application/json as the cart data endpoint,
    // even with sections present. Request the HTML route for section JSON.
    var result = await request(url.toString(), {headers:{Accept:'text/html'}});
    if (!result['cart-drawer'] || result['cart-drawer'].indexOf('data-ss-drawer-version="'+VERSION+'"') < 0 || !result['cart-icon-bubble']) {
      throw new Error('The cart view could not be loaded. Please refresh the page and open your cart again.');
    }
    return result;
  }
  function seedCart() {
    var el = drawer && drawer.querySelector('[data-ss-cart-state]');
    if (!el) return null;
    try {return JSON.parse(el.textContent);} catch (_) {return null;}
  }
  // Shopify renders these sections in the same mutation that returns the Add
  // response. The embedded JSON is the full cart, not just the added line.
  function cartFromSections(result) {
    if (!result || sectionIds().some(function(id){return typeof result[id] !== 'string' || !result[id].trim();})) return null;
    var parsed=new DOMParser().parseFromString(result['cart-drawer'],'text/html');
    var shell=parsed.querySelector('cart-drawer[data-ss-drawer-version="'+VERSION+'"]');
    var seed=shell&&shell.querySelector('[data-ss-cart-state]');
    if (!seed) return null;
    try {
      var cart=JSON.parse(seed.textContent);
      if(!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count<0 ||
        !Number.isSafeInteger(cart.total_price) || cart.total_price<0) return null;
      model.groups(cart); // Also validates unique line keys and quantities.
      if(cart.items.reduce(function(sum,item){return sum+item.quantity;},0)!==cart.item_count) return null;
      return cart;
    } catch (_) {return null;}
  }
  function addedLines(state) {
    if(!state || state.status || state.errors) return [];
    return (Array.isArray(state.items)?state.items:(state.key?[state]:[])).map(function(item){
      var line=Object.assign({},item);delete line.sections;return line;
    });
  }
  function responseMatchesCart(cart, added) {
    if(!cart || !added.length) return false;
    // An Add cannot remove a previously acknowledged line. This also rejects
    // an older response that arrives after another design was already rendered.
    if(currentCart&&Array.isArray(currentCart.items)&&currentCart.items.some(function(previous){
      var next=cart.items.find(function(item){return item.key===previous.key;});
      return !next||next.quantity<previous.quantity;
    }))return false;
    return added.every(function(line){
      var item=cart.items.find(function(i){return i.key===line.key;});
      if(!item || !Number.isSafeInteger(line.quantity) || line.quantity<1 || item.quantity!==line.quantity) return false;
      var properties=line.properties||{};
      if(Object.keys(properties).some(function(key){return JSON.stringify(properties[key])!==JSON.stringify((item.properties||{})[key]);})) return false;
      var group=properties['_customily-upsell-main-id'];
      // In Customily's raw-fetch path, sections from the main request can
      // predate the addon request. Reconcile once after it has been acknowledged.
      return properties._ss_cu_offer || !group || cart.items.some(function(child){return (child.properties||{})['_customily-upsell-id']===group;});
    });
  }
  function rowFor(key) {
    return Array.from(drawer.querySelectorAll('[data-ss-cart-key]')).find(function (el) {return el.dataset.ssCartKey === key;});
  }
  function groupRows(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var index=0;
    model.groups(cart).forEach(function (group) {
      [group.item].concat(group.addons).forEach(function (item, child) {
        var row=rowFor(item.key); if (!row) return;
        row.style.order=String(index++);
        row.dataset.ssLinked=child ? 'true' : 'false';
      });
    });
  }
  function overlayOpen() {return !!(window.SoulyshineCartUI && window.SoulyshineCartUI.isOverlayOpen());}
  function setBusy(value) {
    busy=value;
    if (!drawer) return;
    drawer.setAttribute('aria-busy',String(value));
    drawer.querySelectorAll('[data-ss-cart-step], [data-ss-cart-remove], [data-ss-cart-quantity], [data-ss-cu-check], #CartDrawer-Checkout').forEach(function (el) {
      if (value) {
        if (!Object.prototype.hasOwnProperty.call(el.dataset,'ssWasDisabled')) el.dataset.ssWasDisabled=el.disabled?'true':'false';
        el.disabled=true;
      } else if (Object.prototype.hasOwnProperty.call(el.dataset,'ssWasDisabled')) {
        el.disabled=el.dataset.ssWasDisabled==='true';delete el.dataset.ssWasDisabled;
      }
    });
  }
  function error(message) {
    var el=drawer && drawer.querySelector('#CartDrawer-CartErrors');
    if (el) el.textContent=message || '';
    var pageError=document.getElementById('cart-errors');
    if (pageError) pageError.textContent=message || '';
    if(message && currentCart) document.querySelectorAll('[data-ss-cart-key],cart-items .ink-cart-row').forEach(function(row){
      var key=row.dataset.ssCartKey||row.dataset.itemKey;
      var item=currentCart.items.find(function(i){return i.key===key;});
      var input=row.querySelector('[data-ss-cart-quantity],.quantity__input');
      if(item&&input)input.value=item.quantity;
    });
    if (message) document.dispatchEvent(new CustomEvent('soulyshine:drawer:error', {detail:{message:message}}));
  }
  function remember() {
    var state={details:[], key:null, control:null, upsell:null};
    drawer.querySelectorAll('[data-ss-cart-key]').forEach(function (row) {
      var toggle=row.querySelector('.ink-toggle-details');
      if (toggle && toggle.getAttribute('aria-expanded')==='true') state.details.push(row.dataset.ssCartKey);
    });
    var active=document.activeElement, row=active && active.closest('[data-ss-cart-key]');
    if(active && active.hasAttribute('data-ss-cu-check'))state.upsell=active.dataset.ssCuOffer;
    if (row) {state.key=row.dataset.ssCartKey;state.control=active.hasAttribute('data-ss-cart-quantity')?'input':active.getAttribute('data-ss-cart-step');}
    return state;
  }
  function restore(state, detailsOnly) {
    state.details.forEach(function (key) {
      var row=rowFor(key), toggle=row&&row.querySelector('.ink-toggle-details');
      if(!toggle)return;var panel=document.getElementById(toggle.dataset.target);
      if(panel){panel.hidden=false;toggle.setAttribute('aria-expanded','true');var label=toggle.querySelector('.ink-toggle-label');if(label)label.textContent='Hide details';}
    });
    if (detailsOnly || !drawer.classList.contains('active') || overlayOpen()) return;
    var row=state.key&&rowFor(state.key);
    var target=row&&(state.control==='input'?row.querySelector('[data-ss-cart-quantity]'):Array.from(row.querySelectorAll('[data-ss-cart-step]')).find(function(b){return b.dataset.ssCartStep===state.control;}));
    if(state.upsell)target=Array.from(drawer.querySelectorAll('[data-ss-cu-check]')).find(function(el){return el.dataset.ssCuOffer===state.upsell;});
    target=target||drawer.querySelector('.drawer__close');
    if(typeof trapFocus==='function')trapFocus(drawer.querySelector('#CartDrawer'),target);
  }
  function bindCartElements() {
    // Preserve Shrine's component API while routing this theme's cart edits
    // through one key-based writer. Do not replace product-form/ATC handlers.
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if(el.__ssDrawerBound)return;el.__ssDrawerBound=true;
      el.onCartUpdate=function(){};
      el.onChange=function(){};
      el.updateCart=function(){return refresh(false);};
      el.updateQuantity=function(line, quantity){
        var selector=el.tagName==='CART-ITEMS'?'#CartItem-'+line:'#SSCartDrawer-Item-'+line;
        var row=el.querySelector(selector)||el.querySelector('[data-index="'+line+'"]');
        if(row)row=row.closest('[data-ss-cart-key],.ink-cart-row')||row;
        var key=row&&(row.dataset.ssCartKey||row.dataset.itemKey||row.dataset.key);
        if(key)return change(key,Number(quantity));
        return refresh(false);
      };
    });
  }
  function render(result, cart, shouldOpen, source, added) {
    var state=remember();
    // Disabling a focused control may already have blurred it. Keep the focus
    // identity captured before the task became busy if the user has not moved on.
    if(taskFocus&&taskFocus.revision===interactionRevision){state.key=taskFocus.state.key;state.control=taskFocus.state.control;state.upsell=taskFocus.state.upsell;}
    nativeRendering=true;
    try {originalRender({sections:result},true);} finally {nativeRendering=false;}
    ['main-cart-items','main-cart-footer'].forEach(function(id){
      var el=document.getElementById(id);if(!el||!result[el.dataset.id])return;
      var parsed=new DOMParser().parseFromString(result[el.dataset.id],'text/html').getElementById(id);
      var target=el.querySelector('.js-contents'), source=parsed&&parsed.querySelector('.js-contents');
      if(target&&source)target.innerHTML=source.innerHTML;
      el.classList.toggle('is-empty',cart.item_count===0);
      var outer=el.closest('cart-items');if(outer)outer.classList.toggle('is-empty',cart.item_count===0);
    });
    currentCart=seedCart()||cart;
    drawer.setAttribute('data-ss-cart-render-source',source||'soulyshine-drawer');
    drawer.classList.toggle('is-empty',currentCart.item_count===0);
    groupRows(currentCart);bindCartElements();
    // Section replacement creates new controls. Record their own disabled
    // state rather than enabling checkout or overwriting an existing snapshot.
    if(busy)setBusy(true);
    if(window.SoulyshineCartUI)window.SoulyshineCartUI.refresh();
    if(shouldOpen&&!overlayOpen()) {originalOpen(document.activeElement);}
    else {
      restore(state,true);
      if(taskFocus&&taskFocus.revision===interactionRevision)pendingFocusRestore={state:state,revision:interactionRevision};
    }
    // Keep review navigation on the same unpublished theme.
    if(previewId)drawer.querySelectorAll('a[href]').forEach(function(a){var u=new URL(a.href,location.origin);if(u.origin===location.origin){u.searchParams.set('preview_theme_id',previewId);a.href=u.toString();}});
    var status=drawer.querySelector('#CartDrawer-LineItemStatus');
    var countHeading=drawer.querySelector('[data-ss-main-item-count]');
    var mainCount=countHeading?Number(countHeading.dataset.ssMainItemCount):null;
    if(status)status.textContent=Number.isSafeInteger(mainCount)?'Cart updated. '+mainCount+(mainCount===1?' item.':' items.'):'Cart updated.';
    var detail={source:source||'soulyshine-drawer',renderer:'soulyshine-drawer',cart:currentCart,cartUpdatedAt:Date.now()};
    if(added&&added.length)detail.addedItems=added;
    document.dispatchEvent(new CustomEvent('soulyshine:cart:updated',{detail:detail}));
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:detail}));
    document.dispatchEvent(new CustomEvent('soulyshine:drawer:ready',{detail:{cart:currentCart}}));
  }
  function queue(task) {
    pendingTasks++;
    running=running.catch(function(){}).then(async function(){
      taskFocus={state:remember(),revision:interactionRevision};pendingFocusRestore=null;
      setBusy(true);error('');
      try{return await task();}catch(e){error(e.message);throw e;}
      finally{
        pendingTasks--;
        setBusy(false);
        var focus=pendingFocusRestore;pendingFocusRestore=null;taskFocus=null;
        if(focus&&focus.revision===interactionRevision)restore(focus.state);
        if(queuedRefresh)scheduleRefreshTimer();
      }
    });
    return running;
  }
  function renderAddResponse(state, shouldOpen) {
    var cart=cartFromSections(state&&state.sections), added=addedLines(state);
    var useResponse=pendingTasks===0&&responseMatchesCart(cart,added);
    var requestedCloseRevision=closeRevision, requestedExternalRevision=externalRevision;
    pendingAddRenders++;
    var task=queue(async function(){
      var result, usedResponse=useResponse&&requestedExternalRevision===externalRevision;
      if(usedResponse){
        result=state.sections;
      }else{
        // Missing/stale sections need one fresh rendered view. Its embedded
        // cart JSON also supplies CRM, avoiding a separate cart.js read/poll.
        result=await sections();cart=cartFromSections(result);
        if(!cart)throw new Error('The cart data could not be loaded. Please refresh the page and open your cart again.');
      }
      // Earlier addon/cart notifications are already represented by this
      // acknowledged snapshot. Keep a follow-up for later external changes.
      if(requestedExternalRevision===externalRevision){
        queuedRefresh=false;clearTimeout(refreshTimer);refreshTimer=null;
      }
      render(result,cart,shouldOpen&&requestedCloseRevision===closeRevision,
        usedResponse?'soulyshine-add-response':'soulyshine-add-reconcile',added);
      return currentCart;
    });
    return task.finally(function(){pendingAddRenders--;});
  }
  function refresh(shouldOpen, afterAdd, source) {
    // Capture at enqueue time so a close also cancels opens waiting behind
    // another cart operation. A later deliberate open starts a new request.
    var requestedCloseRevision=closeRevision;
    return queue(async function(){
      var cart=afterAdd?await settledCart():await readCart();
      var result=await sections();
      render(result,cart,shouldOpen&&requestedCloseRevision===closeRevision,source);
      return currentCart;
    });
  }
  function enrichRules(cart) {
    cart.items.forEach(function(item){var row=rowFor(item.key),input=row&&row.querySelector('[data-ss-cart-quantity]');if(input)item.quantity_rule={min:Number(input.min)||1,max:input.max?Number(input.max):null,increment:Number(input.step)||1};});
    return cart;
  }
  function inventoryCheck(cart, updates) {
    var totals={};cart.items.forEach(function(item){totals[item.variant_id]=(totals[item.variant_id]||0)+(Object.prototype.hasOwnProperty.call(updates,item.key)?updates[item.key]:item.quantity);});
    cart.items.forEach(function(item){var row=rowFor(item.key);if(row&&row.dataset.ssInventoryManaged==='true'&&updates[item.key]>item.quantity&&totals[item.variant_id]>Number(row.dataset.ssInventoryQuantity))throw new Error('The requested quantity is not available. Please choose a lower quantity.');});
  }
  async function writeUpdates(updates) {
    var keys=Object.keys(updates);if(!keys.length)return readCart();
    // Customily's documented-in-source bypass prevents a second addon writer
    // from transforming this already-complete atomic plan. Product ATC is unchanged.
    var single=keys.length===1;
    var body=single?{id:keys[0],quantity:updates[keys[0]]}:{updates:updates};
    return request(route(single?'cart/change.js?customily_upsell=1':'cart/update.js?customily_upsell=1'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
  }
  function change(key, quantity) {
    return queue(async function(){
      var cart=enrichRules(await readCart());
      currentCart=cart;
      var updates=model.planChange(cart,key,quantity);
      inventoryCheck(cart,updates);
      try {cart=await writeUpdates(updates);} catch(e) {
        // Never retry a potentially-applied mutation. Reconcile the display once.
        try{var recovered=await readCart();render(await sections(),recovered,false);}catch(_){}
        throw e;
      }
      var integrity=model.planIntegrity(cart);
      if(Object.keys(integrity).length)cart=await writeUpdates(integrity);
      render(await sections(),cart,false);
      return currentCart;
    });
  }

  // A set uses the existing serialized cart queue and one Shopify add request.
  function addSet(items) {
    if(!originalRender)return Promise.reject(new Error('Your cart is still loading. Please try again.'));
    return queue(async function(){
      var state;
      try {
        state=await request(route('cart/add.js?customily_upsell=1'),{
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:items,sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search})
        });
      }catch(e){
        e.cartUncertain=true;
        try{var recovered=await readCart();render(await sections(),recovered,true,'soulyshine-drawer');}catch(_){}
        e.message='Your set could not be confirmed. Please review your cart before trying again.';
        throw e;
      }
      try{
        var result=state.sections,cart=cartFromSections(result);
        if(!cart){result=await sections();cart=cartFromSections(result)||await readCart();}
        render(result,cart,true,'soulyshine-drawer',addedLines(state));
        return{added:true,rendered:true};
      }catch(e){return{added:true,rendered:false};}
    });
  }

  // The same queue serializes upsells, normal quantities, and drawer refreshes.
  function toggleUpsell(offerId, checked, catalog) {
    return queue(async function () {
      var rules=window.SSCartUpsellRules;
      if(!rules)throw new Error('Matching accessories are still loading. Please try again.');
      var cart=await readCart();
      currentCart=cart;
      var offer=rules.buildOffers(cart,catalog).find(function(candidate){return candidate.id===offerId;});
      var result, added=[];
      try {
        if(checked){
          if(!offer)throw new Error('Your cart changed. Please choose a matching accessory again.');
          if(!offer.addedLineKeys.length && !offer.externalAdded){
            var response=await request(route('cart/add.js?customily_upsell=1'),{
              method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({items:[{id:offer.variantId,quantity:1,properties:offer.properties}],
                sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search})
            });
            added=addedLines(response);
            cart=cartFromSections(response.sections);
            if(cart)result=response.sections;
          }
        }else{
          // Only remove lines owned by this specific offer, using current keys.
          var updates={};
          cart.items.forEach(function(item){
            if((item.properties||{})._ss_cu_offer===offerId)updates[item.key]=0;
          });
          if(Object.keys(updates).length)cart=await writeUpdates(updates);
        }
        if(!result){result=await sections();cart=cartFromSections(result)||await readCart();}
        render(result,cart,false,'soulyshine-drawer',added);
        return currentCart;
      }catch(e){
        // Never retry a mutation blindly: reconcile a possible acknowledged add.
        try{var recovered=await readCart();render(await sections(),recovered,false,'soulyshine-drawer');}catch(_){}
        throw e;
      }
    });
  }
  function catchAction(promise){promise.catch(function(e){console.warn('[Soulyshine drawer]',e.message);});}
  function rowKey(row){return row&&(row.dataset.ssCartKey||row.dataset.itemKey);}
  function onClick(event){
    var addButton=event.target.closest&&event.target.closest('#customily-cart-btn,form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]');
    // Only stop a new user initiation. Customily's synthetic original-button
    // click can belong to an already-running design whose addons are saved.
    if(pendingAddRenders&&event.isTrusted&&addButton){event.preventDefault();event.stopImmediatePropagation();return;}
    // Shrine binds the initial backdrop directly to its original close method
    // in its constructor. Capture that click too, before the bound handler runs.
    var closeTarget=event.target.closest&&event.target.closest('#CartDrawer-Overlay,.drawer__close');
    if(closeTarget&&drawer.contains(closeTarget)){closeRevision++;return;}
    var target=event.target.closest&&event.target.closest('[data-ss-cart-step],[data-ss-cart-remove], cart-items .ink-cart-row cart-remove-button');
    if(!target)return;
    var row=target.closest('[data-ss-cart-key],.ink-cart-row'),key=rowKey(row);if(!key)return;
    event.preventDefault();event.stopImmediatePropagation();if(busy)return;
    var input=row.querySelector('[data-ss-cart-quantity],.quantity__input');
    var quantity=target.hasAttribute('data-ss-cart-step')?Number(input.value)+Number(target.dataset.ssCartStep)*(Number(input.step)||1):0;
    catchAction(change(key,Math.max(0,quantity)));
  }
  function onChange(event){
    var target=event.target;if(!target.matches('[data-ss-cart-quantity], cart-items .ink-cart-row .quantity__input'))return;
    var key=rowKey(target.closest('[data-ss-cart-key],.ink-cart-row'));if(!key)return;
    event.stopImmediatePropagation();if(busy)return;catchAction(change(key,Number(target.value)));
  }
  function scheduleExternalRefresh(event){
    if(event&&event.detail&&(event.detail.source==='soulyshine-drawer'||event.detail.renderer==='soulyshine-drawer'))return;
    externalRevision++;queuedRefresh=true;scheduleRefreshTimer();
  }
  function scheduleRefreshTimer(){
    clearTimeout(refreshTimer);refreshTimer=setTimeout(function(){
      refreshTimer=null;
      // Keep only one follow-up while another task is reading/writing the cart.
      // Its finally block will schedule this after the active task completes.
      if(busy||!queuedRefresh)return;
      queuedRefresh=false;catchAction(refresh(false));
    },300);
  }
  async function boot(){
    drawer=document.querySelector('cart-drawer[data-ss-drawer-version]');model=window.SoulyshineCartModel;
    if(!drawer||!model)return;
    await customElements.whenDefined('cart-drawer');
    originalRender=drawer.renderContents.bind(drawer);originalOpen=drawer.open.bind(drawer);originalClose=drawer.close.bind(drawer);
    drawer.renderContents=function(state,dontOpen){if(nativeRendering)return originalRender(state,dontOpen);var task=renderAddResponse(state,!dontOpen);catchAction(task);return task;};
    drawer.open=function(trigger){if(trigger&&drawer.setActiveElement)drawer.setActiveElement(trigger);originalOpen(trigger);catchAction(refresh(false));};
    drawer.close=function(){closeRevision++;originalClose();};
    currentCart=seedCart();groupRows(currentCart);bindCartElements();
    // Cancel deferred focus restoration when the user starts a new interaction.
    document.addEventListener('pointerdown',function(){interactionRevision++;},true);
    document.addEventListener('keydown',function(){interactionRevision++;},true);
    document.addEventListener('click',onClick,true);document.addEventListener('change',onChange,true);
    document.addEventListener('cart:updated',scheduleExternalRefresh);
    window.addEventListener('pageshow',function(e){if(e.persisted)catchAction(refresh(false));});
  }
  window.SoulyshineDrawer={version:VERSION,build:'20260913-matching-upsell-1',refresh:refresh,change:change,toggleUpsell:toggleUpsell,addSet:addSet,getCart:function(){return currentCart;}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){catchAction(boot());},{once:true});else catchAction(boot());
})();
